import { useContext } from 'react';
import { LegalEntityContext } from '@context';
import { Arrow } from '@public';
import { ClientType } from '@types';

// Styles
import styles from './userAccountClients.module.scss';

interface UserAccountClientsProps {
	onClientClick?: (client: ClientType) => void;
}

export const UserAccountClients = ({
	onClientClick = () => {
		return;
	},
}: UserAccountClientsProps) => {
	// Context
	const { legalEntityList } = useContext(LegalEntityContext);

	return (
		<div className={styles.relationshipsContainer}>
			<table>
				<thead>
					<th>Client name</th>
					<th>Client reference</th>
					<th style={{ textAlign: 'center' }}>Select</th>
				</thead>
				<tbody>
					{legalEntityList.map((legalEntity, index) => (
						<tr
							onClick={() => onClientClick(legalEntity)}
							className={styles.relationship}
							key={index}
							data-testid="clientRow"
						>
							<td>
								<a>{legalEntity.name}</a>
							</td>
							<td>
								<a>{legalEntity.reference}</a>
							</td>
							<td style={{ textAlign: 'center' }}>
								<Arrow customStyles={styles.arrow} />
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
